/**
 * ColumnResizer.tsx
 *
 * Maniglia di ridimensionamento posizionata sul bordo destro di un <Table.Th>.
 * Trascinamento = resize, doppio click = ripristina la larghezza di default.
 * Il <Th> padre deve avere position: relative.
 */

import type { Header } from '@tanstack/react-table';

interface ColumnResizerProps<TData> {
  header: Header<TData, unknown>;
}

export function ColumnResizer<TData>({ header }: ColumnResizerProps<TData>) {
  if (!header.column.getCanResize()) return null;

  const isResizing = header.column.getIsResizing();

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      onMouseDown={header.getResizeHandler()}
      onTouchStart={header.getResizeHandler()}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => {
        e.stopPropagation();
        header.column.resetSize();
      }}
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        height: '100%',
        width: 6,
        cursor: 'col-resize',
        userSelect: 'none',
        touchAction: 'none',
        background: isResizing ? 'var(--mantine-color-blue-5)' : 'transparent',
        zIndex: 1,
      }}
      onMouseEnter={(e) => {
        if (!isResizing) e.currentTarget.style.background = 'var(--mantine-color-blue-3)';
      }}
      onMouseLeave={(e) => {
        if (!isResizing) e.currentTarget.style.background = 'transparent';
      }}
    />
  );
}
